import styled from "styled-components"
import {useState} from "react"
import usuarioLogo from '../imgs/usuario.png';
import {validateUser} from "../services/authentication.js"
import ComboSearch from './ComboSearch'
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {useNavigate} from 'react-router-dom' 
import {useDispatch,useSelector} from 'react-redux';
import {loguin,grupoSelected} from '../redux/actions.js';
import Button from '@mui/material/Button';


const Ingreso=styled.div`
	display:flex;
	flex-direction:column;	
	background-color:white;
	border: none;
	width: 220px;
	height:54vh;
	min-height: 400px; 
	align-items:center;
	border-radius:25px;
	font-size:12px;
	color: #033953;
	text-align:center;
	justify-content:center;
	align-items:center;
	padding:10px;
	-webkit-box-shadow: 18px 13px 40px -6px rgba(0,0,0,0.75);
	-moz-box-shadow: 18px 13px 40px -6px rgba(0,0,0,0.75);
	box-shadow: 18px 13px 40px -6px rgba(0,0,0,0.75);
	
`;

 export const ButtonLogin=styled.button`
	width:80%;
	padding:8px;
	border-radius:8px;
	border:none;
	background-color:#09b5c1
`;


export default function Login(){
	const [showPassword, setShowPassword] = useState(false);
	const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => { event.preventDefault() };
    const navigate=useNavigate();
    let dispatch=useDispatch();
	let usuario=useSelector(state=>state.usuario);

		


    let handleSubmit=async(e)=>{
		e.preventDefault();
		let password=document.getElementById("password").value;
		try{
			
			await validateUser(usuario,password);
			await dispatch(loguin(usuario));
			await dispatch(grupoSelected(`${usuario==="Cesarin"?'Administracion':usuario}`))
			navigate(`/Home/Tutoriales/${usuario==="Cesarin"?'Administracion':usuario}`)		
	}
	catch(err){alert("error de ingreso")}


	
	}

	return(

    <Ingreso >
	    		<img src={usuarioLogo} style={{height:"100px"}}alt="logo usuario"/>
				<div style={{padding:"13px 0px 15px 0px"}} >Ingresa tus datos</div>	
				<form onSubmit={handleSubmit}>
					<ComboSearch />
					<div>


				<FormControl fullWidth  sx={{ m:1, maxWidth: 180 }} size="small" variant="outlined">
					<InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
          	<OutlinedInput id="password" type={showPassword ? 'text' : 'password'}  
          			endAdornment={
          				<InputAdornment position="end">
          					<IconButton  onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
                  		{showPassword ? <VisibilityOff /> : <Visibility />}
                		</IconButton>
              		</InputAdornment>
            		}
            	label="Password"
          	/>
          </FormControl>


		    		</div>
		    		<Button variant="contained" type="submit" size="large" >ingresar</Button>
				</form>
			</Ingreso>


	)}